
define('text!templates/ajax_loader.html',[],function () { return '<div class="container" style="border: none !important;">\n    <div style="padding: 30px; text-align: center; background: url(//i.rusff.me/f/me/rusff/ajax-loader.gif) no-repeat center center;"></div>\n    &nbsp;\n</div>';});

